import { reservationsService } from '@/services/reservations.service.js';

const state = {
  getReservationsOutput: null,
  getReservationByIdOutput: null,
  createReservationOutput: null,
  updateReservationOutput: null,
  confirmReservationOutput: null,
  sendEmailNotificationOutput: null,
  deleteReservationByIdOutput: null
};

const mutations = {
  setGetReservationsOutput(state, payload) {
    state.getReservationsOutput = payload;
  },
  setGetReservationByIdOutput(state, payload) {
    state.getReservationByIdOutput = payload;
  },
  setCreateReservationOutput(state, payload) {
    state.createReservationOutput = payload;
  },
  setUpdateReservationOutput(state, payload) {
    state.updateReservationOutput = payload;
  },
  setConfirmReservationOutput(state, payload) {
    state.confirmReservationOutput = payload;
  },
  setSendEmailNotificationOutput(state, payload) {
    state.sendEmailNotificationOutput = payload;
  },
  setDeleteReservationByIdOutput(state, payload) {
    state.deleteReservationByIdOutput = payload;
  }
};

const actions = {
  async getReservations({ commit }, input) {
    try {
      const response = await reservationsService.getList(input);
      commit('setGetReservationsOutput', response);
      return response;
    } catch (error) {
      console.error('Error fetching reservations list:', error);
      throw error;
    }
  },
  
  async getById({ commit }, id) {
    try {
      const response = await reservationsService.getById(id);
      commit('setGetReservationByIdOutput', response);
      return response;
    } catch (error) {
      console.error('Error fetching reservation by id:', error);
      throw error;
    }
  },
  
  async create({ commit }, data) {
    try {
      const response = await reservationsService.create(data);
      commit('setCreateReservationOutput', response);
      return response;
    } catch (error) {
      console.error('Error creating reservation:', error);
      throw error;
    }
  },
  
  async update({ commit }, data) {
    try {
      const response = await reservationsService.update(data);
      commit('setUpdateReservationOutput', response);
      return response;
    } catch (error) {
      console.error('Error updating reservation:', error);
      throw error;
    }
  },
  
  async confirmReservation({ commit }, id) {
    try {
      const response = await reservationsService.confirm(id);
      commit('setConfirmReservationOutput', response);
      return response;
    } catch (error) {
      console.error('Error confirming reservation:', error);
      throw error;
    }
  },
  
  async cancelReservation({ commit }, id) {
    try {
      const response = await reservationsService.cancel(id);
      commit('setConfirmReservationOutput', response);
      return response;
    } catch (error) {
      console.error('Error cancelling reservation:', error);
      throw error;
    }
  },
  
  
  async sendEmailNotification({ commit }, id) {
    try {
      const response = await reservationsService.sendEmailNotification(id);
      commit('setSendEmailNotificationOutput', response);
      return response;
    } catch (error) {
      console.error('Error sending email notification:', error);
      throw error;
    }
  },
  
  async deleteReservationById({ commit }, id) {
    try {
      const response = await reservationsService.delete(id);
      commit('setDeleteReservationByIdOutput', response);
      return response;
    } catch (error) {
      console.error('Error deleting reservation:', error);
      throw error;
    }
  },

  async updateClientNote({ commit }, { id, clientNote, sendEmail }) {
    try {
      const response = await reservationsService.updateClientNote(id, { clientNote, sendEmail });
      return response;
    } catch (error) {
      console.error('Error updating client note:', error);
      throw error;
    }
  }
};

const getters = {
  reservations: state => state.getReservationsOutput?.data || [],
  reservation: state => state.getReservationByIdOutput || null
};

export const reservations = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};

